export default __webpack_public_path__ + "static/media/doc.7f487763.svg";